<template>
  <v-container class="d-flex align-center justify-center" fluid>
    <div style="width: 100%">
      <v-row class="d-flex justify-center mt-10">
        <div>
          <v-avatar size="70">
            <v-img :src="this.$store.state.currentUser.imageUrl" contain/>
          </v-avatar>
          <h3 class="mt-3">Welcome back {{ this.$store.state.currentUser.firstName }}!</h3>
          <p>Greetings from Swiset</p>
        </div>
      </v-row>
      <v-divider class="my-7 mx-12"/>
      <p v-if="this.$store.state.lastUpdate !== null">{{ lastUpdateFormatted }} was the last data update</p>
      <DashboardAnalytics :users="this.$store.state.users"/>
    </div>
  </v-container>
</template>

<script>
import DashboardAnalytics from "./Analytics/DashboardAnalytics";

export default {
  name: "Dashboard",
  components: {DashboardAnalytics},
  computed: {
    lastUpdateFormatted() {
      if(this.$store.state.lastUpdate !== null) {
        let date = new Date(this.$store.state.lastUpdate);
        return `${String(date.getDate()).padStart(2,'0')}/${String(date.getMonth() + 1).padStart(2,'0')}/${date.getFullYear()} at
          ${String(date.getHours()).padStart(2,'0')}:${String(date.getMinutes()).padStart(2,'0')}`;
      }
      return 'No';
    },
  },
}
</script>

<style scoped>

</style>
